/** @file surfaceContexts: the key contexts whose chords a menu opened on a surface may show. */
import type { MenuSurface } from './registryTypes';

/** `global` plus the surface's own panel context (a chord of another panel does not work where the menu is). */
export function surfaceContexts(surface: MenuSurface): string[] {
  return ['global', surface];
}
